import { render } from "./favouriteArticle.vue?vue&type=template&id=6468f496&scoped=true"
import script from "./favouriteArticle.vue?vue&type=script&lang=js"
export * from "./favouriteArticle.vue?vue&type=script&lang=js"

import "./favouriteArticle.vue?vue&type=style&index=0&id=6468f496&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6468f496"]])

export default __exports__